import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  z-index: 999;
  width: 100%;
  top: 0;
  left: 0;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
`;
